export default __webpack_public_path__ + "static/media/right_arrow_btn.ff0081c3.svg";